<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <b-card
          body-class="p-2 d-flex flex-column flex-sm-column flex-md-row justify-content-between"
          class="shadow-sm"
          border-variant="white"
        >
          <h4 class="m-0 font-weight-bold text-center text-md-left">
            <i class="fas fa-star"></i> {{getAppName}} JACKPOT
          </h4>
          <div>
            <b-badge variant="warning" class="goldenrod w-100">ผลรางวัลออกเลขตามสลากหวยรัฐบาลไทย</b-badge>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <b-card body-class="p-2" class="shadow-sm" border-variant="white">
          <b-row>
            <b-col cols="12" lg="9" class="pr-md-1">
              <b-badge variant="dark" class="mr-2 mb-2">ประจำวันที่</b-badge>{{ lottoDate ? lottoDate : '' }}
              <b-alert
                variant="danger"
                show
                class="small py-1 px-2"
              >เงินรางวัล Jackpot จะถูกสะสมขึ้นเรื่อยๆเมื่อไม่มีผู้ถูกรางวัลที่ 1 ในแต่ละงวด</b-alert>
            </b-col>
            <b-col cols="12" lg="3" class="pl-md-1">
              <div class="gold-box p-1 rounded">
                <span
                  class="badge badge-dark text-center font-weight-light w-100 mb-0"
                >ยอด JACKPOT ปัจจุบัน</span>
                <h3 class="text-white mb-0 text-center font-mitr">1,000,000</h3>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <b-card
                border-variant="dark"
                header-bg-variant="light"
                header-class="p-1 text-center"
                body-class="text-center p-1"
              >
                <template #header>
                  <strong>รางวัล JACKPOT</strong>
                  <br />
                  <small>(มูลค่า 1,000,000 บาท)</small>
                </template>
                <h3 class="mb-0 font-mitr">{{result ? result.longResult : ''}}</h3>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="lottoInfo.LuckyPerson.length > 0 ">
            <b-col>
              <b-card body-class="text-center pt-2 pb-0 px-2">
                <b-row>
                  <b-col cols="12" md="9">
                    <h4 class="mb-0 font-mitr">
                      ขอแสดงความยินดีกับผู้โชคดี
                      <span class="text-gold">{{lottoInfo.LuckyPerson ? lottoInfo.LuckyPerson.length : 0}} ท่าน</span>
                    </h4>
                    <b-badge variant="dark" class="mr-2">ประจำงวดวันที่</b-badge>{{ lottoDate ? lottoDate : '' }}
                    <br />
                    <small class="text-gold">*เงินรางวัลจะถูกเเบ่งเท่ากับจำนวนผู้ถูกรางวัลทั้งหมด</small>
                  </b-col>
                  <b-col cols="12" md="3">
                    <b-alert variant="danger" show class="p-1">
                      <b-badge class="w-100 font-weight-normal" variant="light">รางวัลละ</b-badge>
                      <h3 class="mb-0 font-mitr text-gold">{{lottoInfo.LuckyPerson.length > 0 ? lottoInfo.LuckyPerson[0].WonPrice.toLocaleString() : 0}}</h3>
                    </b-alert>
                  </b-col>
                  <b-col cols="12" class="mt-2">
                    <b-row>
                      <b-col cols="12" md="4" v-for="(item,index) in lottoInfo.LuckyPerson" v-bind:key="index" class="mb-3">
                        <div class="rounded table-secondary w-100 px-2 text-left">
                          {{item.Name}}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "Result",
  props:['lottoInfo'],
  data(){
    // console.log(this.lottoInfo);
    return {
      // result: null
    };
  },
  created() {
    // this.getLottoResult();
  },
  method:{
    formatDate(datetime, format) {
      return moment(String(datetime)).format(format);
    }
    // getLottoResult() {
    //   this.result = this.lottoInfo.result;
    //   console.log(this.result);
    // }
  },
  computed: {
    result() {
      return this.lottoInfo.result;
    },
    lottoDate(){
      return this.lottoInfo.lottoDateDesc;
    },
    ...mapGetters({
      getAppName: "getAppName"
    })
  }
};
</script>

<style lang="scss" scoped>
.goldenrod {
  background-color: goldenrod;
  font-weight: normal;
  color: #fff;
}

.text-gold {
  color: rgb(189, 132, 41) !important;
}

.gold-box {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07 !important;
  text-shadow: black 1px 1px 3px;
}

.font-mitr {
  font-family: "Mitr", sans-serif;
}
</style>